import React from 'react';
import { Grid, FormControlLabel, Checkbox, FormControl, Select, MenuItem, IconButton, TextField, Chip } from '@mui/material';
import DeleteIcon from "@mui/icons-material/Delete";
import AgyleButton from '../../ui/buttons/agyleButton';
import { CustomAutocomplete } from '../../../controls/uploadIMAGE';
import { useTranslation } from 'react-i18next';

const SmartViewStep = ({
    step,
    index,
    options,
    displayImagePref,
    viewDisplay,
    onSetTest,
    onSetHistory,
    onSetView,
    onDelete,
    onSetDefault,
    onResetDefault,
    isDefault,
    onOpenDisplayDialog
}) => {
    const { t } = useTranslation();

    const getValue = (value, idx) => {
        if (idx !== 0) return value;
        if (Array.isArray(value)) return value;
        return [value];
    };

    return (
        <Grid item xs={12}>
            <Grid container alignItems={"center"}>
                <Grid item xs={4}>
                    {options &&
                        <CustomAutocomplete
                            disableListWrap
                            options={options}
                            getOptionLabel={(option) => option && option.name ? option.name : option}
                            style={{ width: "100%" }}
                            value={getValue(step.test, index)}
                            multiple={index === 0}
                            onChange={(event, newValue) => {
                                onSetTest(newValue);
                            }}
                            renderTags={(tagValue, getTagProps) =>
                                tagValue.map((option, index2) => {
                                    return (
                                        <Chip
                                            key={index + "_" + index2}
                                            label={option && option.name ? option.name : option}
                                            color={isDefault(option) ? "primary" : "default"}
                                            clickable
                                            style={{ margin: 3 }}
                                            onClick={() => {
                                                onSetDefault(option);
                                            }}
                                            onDoubleClick={() => {
                                                onResetDefault(option);
                                            }}
                                            onDelete={() => {
                                                onResetDefault(option);
                                                let newValue = [...getValue(step.test, index)];
                                                newValue.splice(index2, 1);
                                                onSetTest(newValue);
                                            }}
                                        />
                                    );
                                })
                            }
                            getOptionSelected={(option, value) => option.name === value}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{
                                        '& label.Mui-focused': {
                                            color: 'inherit',
                                        },
                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: 'inherit',
                                            borderWidth: '1px',
                                        },
                                    }}
                                    size="small" label={index === 0 ? t("Smart View available in ") : t("Tab ")+index}
                                    placeholder={t("select doctype")}
                                    variant="outlined" />}
                        />
                    }
                </Grid>
                <Grid item xs={3}>
                    <div style={{ textAlign: "center" }}>
                        {index !== 0 &&
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={step.type === "history"}
                                        onChange={(event) => {
                                            onSetHistory(event.target.checked);
                                        }}
                                    />}
                                label={"History"}
                            />
                        }
                    </div>
                </Grid>
                <Grid item xs={4}>
                    {index !== 0 && <FormControl sx={{ width: "100%" }}>
                        <Select
                            value={displayImagePref[step.test] || null}
                            displayEmpty
                            onChange={(event) => {
                                onSetView(step.test, event.target.value);
                            }}
                        >
                            <MenuItem value={null}>
                                <em>Normal</em>
                            </MenuItem>

                            {viewDisplay && viewDisplay.map(r => {
                                return (<MenuItem value={r.value} key={r.name}>{r.name}</MenuItem>)
                            })
                            }
                        </Select>
                    </FormControl>
                    }
                    {index === 0 &&
                        <FormControl sx={{ width: "100%" }}>
                            <AgyleButton
                                onClick={onOpenDisplayDialog}
                                // colour="primary"
                            >
                                {t("Set Image display")}
                            </AgyleButton>
                        </FormControl>
                    }
                </Grid>
                <Grid item xs={1}>
                    <div style={{ textAlign: "center" }}>
                        <IconButton
                            size="small"
                            disableRipple={true}
                            onClick={onDelete}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default SmartViewStep;
